import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type { TableLayoutSettings } from 'lumen/components/hotel/budget-forecast/table/layout-settings';
import HotelBudgetController from 'lumen/controllers/hotel/budget';
import type { ResourceDataType } from 'lumen/models/budget-forecast/data-item';
import type HotelForecastRoute from 'lumen/routes/hotel/forecast';
import {
  type DataType,
  FORECAST_VIEW_DATA_TYPE_ORDER,
} from 'lumen/utils/constants/budget-forecast-constants';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelForecastController extends HotelBudgetController {
  declare model: ModelFrom<HotelForecastRoute>;

  @service declare router: Services['router'];

  @tracked dataTypes: DataType[] = [
    'forecast',
    ...FORECAST_VIEW_DATA_TYPE_ORDER,
  ];
  @tracked expandedRowIds: string[] = [];
  @tracked layoutSettings: TableLayoutSettings = {
    hiddenDataTypes: [],
    pinnedDataTypes: [],
    unpinnedDataTypes: FORECAST_VIEW_DATA_TYPE_ORDER,
  };

  baseDataType: ResourceDataType = 'forecast';

  @action
  redirectToSettingsPage(): void {
    this.usageAnalytics.track('Forecast Page Viewed', {
      eventTrigger: 'settings-forecast-clicked',
    });

    this.router.transitionTo('hotel.settings.forecast');
  }
}
